import { HydraState, RequestHeaders } from '@src/constants';

// this creates headers to be sent to NextJS API routes, not an external source to this app.
export default function makeRequestHeaders({
	sessionId = 'N/A',
	enableHydraCalls = false,
}: { sessionId?: string | undefined; enableHydraCalls?: boolean } = {}): Record<string, string> {
	if (sessionId === 'N/A') {
		console.error(
			'sessionId should always be set but is defaulting to "N/A". This will cause issues with session tracking.'
		);
	}

	return {
		[RequestHeaders.SESSION_ID]: sessionId,
		[RequestHeaders.HYDRA]: enableHydraCalls ? HydraState.ON : HydraState.OFF,
	};
}
